package com.hyperether.goodjob.models

enum class JobFilter(val value: Int) {
    STATUS(0),
    ASSIGNEE(1),
    LOCATION(2),
    SCHEDULE(3)
}